import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVolumeOff: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"volume-off, sound-off"} maskId="square-filled-radius-0-stroke-1-IconVolumeOff"><path d="M13 2.88428V21.1157L5.86611 17H1V6.99998H5.86611L13 2.88428Z" fill="currentColor"/><path d="M20.0858 12.1214L22.2071 10.0001L21.5 9.29295L19.3787 11.4143L17.2573 9.29295L16.5502 10.0001L18.6716 12.1214L16.5502 14.2427L17.2573 14.9498L19.3787 12.8285L21.5 14.9498L22.2071 14.2427L20.0858 12.1214Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconVolumeOff;
